var _path, _path2, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppStoreBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download_on_the_App_Store_Badge",
    xmlns: "http://www.w3.org/2000/svg",
    width: 216,
    height: 64,
    viewBox: "0 0 216 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32258",
    "data-name": "Path 32258",
    d: "M208.315,64H7.566A7.584,7.584,0,0,1,0,56.427V7.562A7.573,7.573,0,0,1,7.566,0H208.315A7.676,7.676,0,0,1,216,7.562V56.427A7.687,7.687,0,0,1,208.315,64Z",
    fill: "#a6a6a6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32259",
    "data-name": "Path 32259",
    d: "M213.917,55.895a6.128,6.128,0,0,1-6.134,6.128H7.032A6.136,6.136,0,0,1,.89,55.895V7.026A6.144,6.144,0,0,1,7.032.89H207.781a6.135,6.135,0,0,1,6.134,6.136l0,48.869Z",
    transform: "translate(0.534 0.534)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25866",
    "data-name": "Group 25866",
    transform: "translate(20.467 9.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25865",
    "data-name": "Group 25865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32260",
    "data-name": "Path 32260",
    d: "M40.53,24.232a9.275,9.275,0,0,1,4.418-7.782A9.5,9.5,0,0,0,37.466,12.4c-3.147-.331-6.2,1.883-7.8,1.883-1.635,0-4.1-1.851-6.765-1.8A9.961,9.961,0,0,0,14.514,17.6c-3.626,6.277-.922,15.5,2.552,20.574,1.738,2.485,3.768,5.259,6.426,5.162,2.6-.107,3.571-1.658,6.709-1.658,3.109,0,4.021,1.658,6.731,1.6,2.79-.045,4.547-2.5,6.224-5A20.532,20.532,0,0,0,46,32.478,8.966,8.966,0,0,1,40.53,24.232Z",
    transform: "translate(-12.792 -2.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32261",
    "data-name": "Path 32261",
    d: "M29.221,12.759a9.129,9.129,0,0,0,2.09-6.542A9.3,9.3,0,0,0,25.3,9.327a8.688,8.688,0,0,0-2.144,6.3A7.681,7.681,0,0,0,29.221,12.759Z",
    transform: "translate(-6.603 -6.217)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25867",
    "data-name": "Group 25867",
    transform: "translate(67.856 28.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32262",
    "data-name": "Path 32262",
    d: "M60.386,39.489H56.752l-1.99-6.254H47.844l-1.9,6.254H42.41L49.264,18.2H53.5ZM54.162,30.61l-1.8-5.56q-.286-.852-1.074-4.011h-.064Q50.91,22.4,50.213,25.05l-1.768,5.56Z",
    transform: "translate(-42.41 -17.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32263",
    "data-name": "Path 32263",
    d: "M70.207,29.514A8.725,8.725,0,0,1,68.09,35.7a6.189,6.189,0,0,1-4.707,2.022,4.707,4.707,0,0,1-4.36-2.179h-.064v8.088H55.547V27.081q0-2.462-.126-5.054h3l.19,2.434h.064a6.069,6.069,0,0,1,9.714-.6A8.459,8.459,0,0,1,70.207,29.514Zm-3.475.125a6.321,6.321,0,0,0-1.011-3.7,3.492,3.492,0,0,0-2.97-1.517,3.547,3.547,0,0,0-2.29.837,3.881,3.881,0,0,0-1.342,2.2,4.466,4.466,0,0,0-.158,1.04v2.56a4.1,4.1,0,0,0,1.027,2.829,3.4,3.4,0,0,0,2.669,1.154,3.492,3.492,0,0,0,3-1.485A6.535,6.535,0,0,0,66.731,29.639Z",
    transform: "translate(-34.603 -15.775)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32264",
    "data-name": "Path 32264",
    d: "M81.243,29.514a8.718,8.718,0,0,1-2.118,6.19,6.184,6.184,0,0,1-4.706,2.022,4.7,4.7,0,0,1-4.358-2.179H70v8.088H66.585V27.081q0-2.462-.126-5.054h3l.19,2.434h.064a6.071,6.071,0,0,1,9.715-.6A8.483,8.483,0,0,1,81.243,29.514Zm-3.475.125a6.321,6.321,0,0,0-1.013-3.7,3.488,3.488,0,0,0-2.968-1.517,3.552,3.552,0,0,0-2.291.837,3.879,3.879,0,0,0-1.341,2.2A4.554,4.554,0,0,0,70,28.5v2.56a4.115,4.115,0,0,0,1.024,2.829,3.412,3.412,0,0,0,2.672,1.154,3.492,3.492,0,0,0,3-1.485A6.535,6.535,0,0,0,77.768,29.639Z",
    transform: "translate(-27.981 -15.775)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32265",
    "data-name": "Path 32265",
    d: "M92.993,33.635A5.675,5.675,0,0,1,91.1,38.057a8.382,8.382,0,0,1-5.8,1.864,10.153,10.153,0,0,1-5.518-1.326l.79-2.843a9.351,9.351,0,0,0,4.931,1.36,4.662,4.662,0,0,0,3-.87,2.842,2.842,0,0,0,1.072-2.326,2.966,2.966,0,0,0-.885-2.182,8.225,8.225,0,0,0-2.938-1.646Q80.165,28,80.167,23.98a5.4,5.4,0,0,1,1.96-4.3A7.727,7.727,0,0,1,87.34,18a10.335,10.335,0,0,1,4.832,1.011l-.853,2.781a8.384,8.384,0,0,0-4.075-.979,4.125,4.125,0,0,0-2.81.885,2.528,2.528,0,0,0-.853,1.928,2.6,2.6,0,0,0,.978,2.085,11.049,11.049,0,0,0,3.1,1.643A10.509,10.509,0,0,1,91.7,29.943,5.409,5.409,0,0,1,92.993,33.635Z",
    transform: "translate(-19.986 -18.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32266",
    "data-name": "Path 32266",
    d: "M98.594,25.9h-3.76v7.454q0,2.844,1.99,2.843a6.067,6.067,0,0,0,1.515-.158l.094,2.59a7.729,7.729,0,0,1-2.653.378,4.093,4.093,0,0,1-3.16-1.232,6.052,6.052,0,0,1-1.138-4.139V25.9h-2.24v-2.56h2.24V20.528l3.35-1.011v3.822h3.76Z",
    transform: "translate(-14.31 -17.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32267",
    "data-name": "Path 32267",
    d: "M111.33,29.576a8.422,8.422,0,0,1-2.022,5.813,7.22,7.22,0,0,1-5.626,2.338A6.866,6.866,0,0,1,98.3,35.485a8.164,8.164,0,0,1-2.006-5.654,8.34,8.34,0,0,1,2.069-5.843,7.16,7.16,0,0,1,5.574-2.275,7.012,7.012,0,0,1,5.434,2.243A8.071,8.071,0,0,1,111.33,29.576Zm-3.539.11a6.906,6.906,0,0,0-.915-3.643,3.369,3.369,0,0,0-3.062-1.837,3.421,3.421,0,0,0-3.128,1.837,7.039,7.039,0,0,0-.915,3.707,6.9,6.9,0,0,0,.915,3.642,3.486,3.486,0,0,0,6.16-.032A6.931,6.931,0,0,0,107.791,29.686Z",
    transform: "translate(-10.081 -15.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32268",
    "data-name": "Path 32268",
    d: "M115.7,25.026a5.923,5.923,0,0,0-1.075-.094,3.223,3.223,0,0,0-2.781,1.36,5.112,5.112,0,0,0-.853,3.032V37.38h-3.41l.032-10.518q0-2.654-.128-4.834h2.971l.125,2.938h.094a5.251,5.251,0,0,1,1.706-2.432,4.125,4.125,0,0,1,2.466-.822,5.477,5.477,0,0,1,.853.062v3.253Z",
    transform: "translate(-3.364 -15.775)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32269",
    "data-name": "Path 32269",
    d: "M127.273,28.987a8,8,0,0,1-.125,1.547H116.914a4.454,4.454,0,0,0,1.485,3.477,5.069,5.069,0,0,0,3.347,1.074,11.318,11.318,0,0,0,4.141-.726l.534,2.368a12.8,12.8,0,0,1-5.147.949,7.457,7.457,0,0,1-5.61-2.1,7.759,7.759,0,0,1-2.037-5.638,8.8,8.8,0,0,1,1.9-5.781,6.537,6.537,0,0,1,5.368-2.462,5.722,5.722,0,0,1,5.026,2.462A8.3,8.3,0,0,1,127.273,28.987ZM124.02,28.1a4.634,4.634,0,0,0-.662-2.622,2.98,2.98,0,0,0-2.718-1.422,3.236,3.236,0,0,0-2.715,1.39,5.091,5.091,0,0,0-1.01,2.653h7.106Z",
    transform: "translate(0.321 -15.786)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25869",
    "data-name": "Group 25869",
    transform: "translate(69.882 10.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25868",
    "data-name": "Group 25868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32270",
    "data-name": "Path 32270",
    d: "M52.274,11.907a5.252,5.252,0,0,1-1.693,4.253,6.733,6.733,0,0,1-4.453,1.318,20.645,20.645,0,0,1-2.453-.125V7.064a18.1,18.1,0,0,1,2.888-.218,6.226,6.226,0,0,1,4.144,1.2A4.83,4.83,0,0,1,52.274,11.907Zm-1.768.046a3.824,3.824,0,0,0-.97-2.81A3.822,3.822,0,0,0,46.7,8.166a7.1,7.1,0,0,0-1.35.109V16.1a8.853,8.853,0,0,0,1.133.046,3.966,3.966,0,0,0,2.971-1.07A4.287,4.287,0,0,0,50.506,11.953Z",
    transform: "translate(-43.676 -6.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32271",
    "data-name": "Path 32271",
    d: "M57.679,12.485a4.137,4.137,0,0,1-.994,2.856,3.546,3.546,0,0,1-2.763,1.149,3.371,3.371,0,0,1-2.646-1.1,4.015,4.015,0,0,1-.984-2.778,4.1,4.1,0,0,1,1.016-2.87,3.524,3.524,0,0,1,2.739-1.117,3.449,3.449,0,0,1,2.67,1.1A3.982,3.982,0,0,1,57.679,12.485Zm-1.739.054a3.411,3.411,0,0,0-.45-1.79,1.656,1.656,0,0,0-1.5-.9,1.682,1.682,0,0,0-1.538.9A3.457,3.457,0,0,0,52,12.57a3.411,3.411,0,0,0,.45,1.79,1.692,1.692,0,0,0,1.522.9,1.673,1.673,0,0,0,1.5-.918A3.39,3.39,0,0,0,55.94,12.54Z",
    transform: "translate(-39.706 -5.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32272",
    "data-name": "Path 32272",
    d: "M66.863,8.719,64.5,16.261H62.967l-.978-3.275a24.514,24.514,0,0,1-.606-2.437h-.03a17.84,17.84,0,0,1-.606,2.437l-1.038,3.275H58.154L55.935,8.719h1.723l.853,3.586q.31,1.272.512,2.421h.03q.187-.946.622-2.4l1.07-3.6h1.366l1.026,3.523q.372,1.289.6,2.483h.046a23.727,23.727,0,0,1,.512-2.483l.915-3.523h1.646Z",
    transform: "translate(-36.321 -5.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32273",
    "data-name": "Path 32273",
    d: "M70.677,16.321H69V12q0-2-1.52-2a1.513,1.513,0,0,0-1.211.549,1.947,1.947,0,0,0-.466,1.293v4.474H64.127V10.934q0-.994-.061-2.158H65.54l.078,1.179h.046a2.423,2.423,0,0,1,.869-.91,2.834,2.834,0,0,1,1.52-.424,2.407,2.407,0,0,1,1.755.683,3.319,3.319,0,0,1,.869,2.5Z",
    transform: "translate(-31.442 -5.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32274",
    "data-name": "Path 32274",
    d: "M71.716,17.559H70.041v-11h1.675Z",
    transform: "translate(-27.857 -6.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32275",
    "data-name": "Path 32275",
    d: "M80.028,12.485a4.137,4.137,0,0,1-.994,2.856,3.549,3.549,0,0,1-2.763,1.149,3.366,3.366,0,0,1-2.646-1.1,4.015,4.015,0,0,1-.984-2.778,4.1,4.1,0,0,1,1.016-2.87,3.523,3.523,0,0,1,2.738-1.117,3.453,3.453,0,0,1,2.672,1.1A3.982,3.982,0,0,1,80.028,12.485Zm-1.741.054a3.411,3.411,0,0,0-.45-1.79,1.654,1.654,0,0,0-1.5-.9,1.679,1.679,0,0,0-1.538.9,3.457,3.457,0,0,0-.45,1.821,3.411,3.411,0,0,0,.45,1.79,1.692,1.692,0,0,0,1.522.9,1.671,1.671,0,0,0,1.5-.918A3.375,3.375,0,0,0,78.287,12.54Z",
    transform: "translate(-26.297 -5.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32276",
    "data-name": "Path 32276",
    d: "M84.652,16.319H83.146l-.125-.869h-.046a2.582,2.582,0,0,1-2.2,1.04,2.274,2.274,0,0,1-1.722-.683,2.142,2.142,0,0,1-.59-1.536,2.343,2.343,0,0,1,1.157-2.11,6,6,0,0,1,3.253-.714v-.141q0-1.49-1.566-1.49a3.508,3.508,0,0,0-1.966.558L79,9.274a4.837,4.837,0,0,1,2.587-.651q2.957,0,2.96,3.12v2.778A11.78,11.78,0,0,0,84.652,16.319Zm-1.741-2.592V12.564q-2.774-.048-2.774,1.52a1.136,1.136,0,0,0,.322.885,1.173,1.173,0,0,0,.819.294,1.693,1.693,0,0,0,1.026-.349,1.432,1.432,0,0,0,.608-1.187Z",
    transform: "translate(-22.806 -5.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32277",
    "data-name": "Path 32277",
    d: "M90.985,17.559H89.5l-.078-1.211h-.046A2.507,2.507,0,0,1,86.95,17.73a2.839,2.839,0,0,1-2.266-1.07,4.17,4.17,0,0,1-.9-2.778,4.373,4.373,0,0,1,.978-2.965,3.006,3.006,0,0,1,2.328-1.056,2.261,2.261,0,0,1,2.125,1.024h.032V6.556h1.678v8.971Q90.926,16.629,90.985,17.559Zm-1.738-3.181V13.121a2.468,2.468,0,0,0-.046-.528,1.91,1.91,0,0,0-.606-1.016,1.648,1.648,0,0,0-1.122-.411A1.721,1.721,0,0,0,86,11.911a3.2,3.2,0,0,0-.538,1.909,2.979,2.979,0,0,0,.515,1.816,1.726,1.726,0,0,0,1.466.744,1.616,1.616,0,0,0,1.325-.621A2.067,2.067,0,0,0,89.247,14.378Z",
    transform: "translate(-19.611 -6.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32278",
    "data-name": "Path 32278",
    d: "M100.018,12.485a4.137,4.137,0,0,1-.994,2.856,3.544,3.544,0,0,1-2.763,1.149,3.375,3.375,0,0,1-2.646-1.1,4.015,4.015,0,0,1-.984-2.778,4.1,4.1,0,0,1,1.016-2.87,3.525,3.525,0,0,1,2.741-1.117,3.446,3.446,0,0,1,2.669,1.1A3.982,3.982,0,0,1,100.018,12.485Zm-1.738.054a3.411,3.411,0,0,0-.45-1.79,1.658,1.658,0,0,0-1.506-.9,1.685,1.685,0,0,0-1.538.9,3.457,3.457,0,0,0-.45,1.821,3.411,3.411,0,0,0,.45,1.79,1.713,1.713,0,0,0,3.027-.016A3.4,3.4,0,0,0,98.281,12.54Z",
    transform: "translate(-14.303 -5.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32279",
    "data-name": "Path 32279",
    d: "M105.362,16.321h-1.675V12q0-2-1.522-2a1.508,1.508,0,0,0-1.21.549,1.939,1.939,0,0,0-.466,1.293v4.474H98.811V10.934q0-.994-.059-2.158h1.472l.078,1.179h.046a2.447,2.447,0,0,1,.869-.91,2.84,2.84,0,0,1,1.522-.424,2.406,2.406,0,0,1,1.754.683,3.313,3.313,0,0,1,.869,2.5Z",
    transform: "translate(-10.63 -5.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32280",
    "data-name": "Path 32280",
    d: "M111.659,10.679h-1.846v3.664c0,.931.328,1.4.978,1.4a2.953,2.953,0,0,0,.747-.078l.043,1.272a3.767,3.767,0,0,1-1.3.187,2,2,0,0,1-1.55-.6,2.958,2.958,0,0,1-.56-2.034v-3.8h-1.1V9.423h1.1V8.041l1.643-.5V9.422h1.846v1.258Z",
    transform: "translate(-5.643 -5.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32281",
    "data-name": "Path 32281",
    d: "M117.94,17.559h-1.678V13.271q0-2.028-1.518-2.029a1.6,1.6,0,0,0-1.6,1.176,2.107,2.107,0,0,0-.078.6v4.536H111.39v-11h1.675V11.1h.032a2.535,2.535,0,0,1,2.266-1.24,2.337,2.337,0,0,1,1.725.683,3.435,3.435,0,0,1,.853,2.53v4.485Z",
    transform: "translate(-3.048 -6.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32282",
    "data-name": "Path 32282",
    d: "M123.722,12.2a4.049,4.049,0,0,1-.062.76H118.63a2.2,2.2,0,0,0,.728,1.707,2.5,2.5,0,0,0,1.646.528,5.555,5.555,0,0,0,2.034-.357L123.3,16a6.315,6.315,0,0,1-2.531.466,3.656,3.656,0,0,1-2.754-1.032,3.8,3.8,0,0,1-1-2.77,4.317,4.317,0,0,1,.931-2.84,3.207,3.207,0,0,1,2.637-1.21,2.805,2.805,0,0,1,2.466,1.21A4.027,4.027,0,0,1,123.722,12.2Zm-1.6-.434a2.257,2.257,0,0,0-.325-1.288,1.465,1.465,0,0,0-1.334-.7,1.592,1.592,0,0,0-1.334.683,2.538,2.538,0,0,0-.5,1.3Z",
    transform: "translate(0.328 -5.321)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreBadge);
export default __webpack_public_path__ + "static/media/app_store_badge.a4687bb12075cd0c56a5588ece0e756c.svg";
export { ForwardRef as ReactComponent };